// extracted by mini-css-extract-plugin
export var corePropsNote = "schema-props-module--corePropsNote--da37d";
export var descText = "schema-props-module--descText--65b61";
export var tableHeading = "schema-props-module--tableHeading--c3992";